import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import AuthForm from './Auth/AuthForm'

const ProtectedRoute = ({ children }) => {
  const { user, loading, initialized } = useAuth()

  // STRICT CHECK: Only show loading if we are NOT initialized.
  // If we are initialized but loading (e.g. signing out), we might still want to show loading,
  // but for the initial load, initialized is the key.
  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <div className="text-gray-500 mb-2">Loading...</div>
          <div className="text-sm text-gray-400">Setting up your session</div>
        </div>
      </div>
    )
  }

  // Show auth form if no user
  if (!user) {
    return <AuthForm />
  }

  // Show protected content if user exists
  return children
}

export default ProtectedRoute